// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1547":"09a875734302933a","6030":"76091fc3ae1119b8","9512":"f7683d3f3f0af48a"}[chunkId] + ".js";
};